const d3 = Object.assign({},
    require('d3-transition'),
    require('d3-selection'),
    require('d3-selection-multi'),
    require('d3-array'),
    require('d3-scale'),
    require('d3-time-format'),
    require('d3-axis'),
    require('d3-shape'));

export class GroupedBarScaler {
    constructor ({ canvas, chartDataHelper }) {
        this.chartDataHelper = chartDataHelper;
        this.canvas = canvas;
        this.context = {
            scale: [],
            axis: []
        };
    }

    buildScales (renderContext) {
        if (!this.chartDataHelper.dataSeries.length) {
            return;
        }
        const rs = renderContext;
        this.context = {
            scale: [],
            axis: []
        };
        const yTicks = (this.chartDataHelper.settings.yAxis && this.chartDataHelper.settings.yAxis.ticks) || 5;
        const innerPadding = (this.chartDataHelper.settings.yAxis && this.chartDataHelper.settings.yAxis.innerPadding) || 0.1;
        const padding = (this.chartDataHelper.settings.yAxis && this.chartDataHelper.settings.yAxis.padding) || 0.05;

        const xScale = d3.scaleBand()
            .domain(this.chartDataHelper.dataSeries[0].metric.map(t => t[0]))
            .rangeRound([0, this.canvas.width - rs.margin.left - rs.margin.right])
            .paddingInner(innerPadding);
        const xGroupScale = d3.scaleBand()
            .domain(this.chartDataHelper.dataSeries.map(el => el.series))
            .rangeRound([0, xScale.bandwidth()])
            .padding(padding);

        const min = (this.chartDataHelper.settings.yAxis &&
                    (this.chartDataHelper.settings.yAxis.minValue !== undefined))
            ? this.chartDataHelper.settings.yAxis.minValue
            : this.chartDataHelper.minMetrics[1];

        const max = (this.chartDataHelper.settings.yAxis &&
            (this.chartDataHelper.settings.yAxis.maxValue !== undefined))
            ? this.chartDataHelper.settings.yAxis.maxValue
            : this.chartDataHelper.maxMetrics[1];

        const yScale = d3.scaleLinear()
            .domain([min, max])
            .range([this.canvas.height - rs.margin.top - rs.margin.bottom, 0])
            .nice(yTicks);
        this.context.scale = [xScale, xGroupScale, yScale];
        this.context.axis.push({
            line: d3.axisBottom(xScale),
            xOffset: rs.margin.left,
            yOffset: this.canvas.height - rs.margin.bottom,
            rotated: true,
            ellipsis: (this.chartDataHelper.settings.xAxis &&
                       this.chartDataHelper.settings.xAxis.ellipsis) || false
        });
        this.context.axis.push({
            line: d3.axisLeft(yScale).ticks(yTicks, 's'),
            xOffset: rs.margin.left,
            yOffset: rs.margin.top
        });
    }

    get axis () {
        return this.context.axis;
    }

    get x () {
        return this.context.scale[0];
    }

    get xGroup () {
        return this.context.scale[1];
    }

    get y () {
        return this.context.scale[2];
    }
}
